((holidayBundleBagCart, $) => {
  "use strict";
  const $dom = {};

  const cacheDom = () => {
    $dom.addKitCart = $(".js-holiday-travel-btn");
    $dom.addBundleToCart = $(".js-holiday-bag-btn");
    $dom.quickView = $(".js-holiday-bag-btn");
    $dom.quickViewClose = $(".js-holiday-bag-modal .quickview-close");
    $dom.quickViewBg = $(".js-holiday-bag-modal .modal--background");
  };

  const bindUIActions = () => {
    //Bind click to show modal quickview
    $dom.addKitCart.on("click", event => {
      const $this = $(event.currentTarget);
      const productsToAdd = $this
        .attr("data-product-handles")
        .replace(/\s+/g, "")
        .split(",");
      const variantId1 = $(".js-holiday-bundle-form-1")
        .find('[name="id"]')
        .val();
      const variantId2 = $(".js-holiday-bundle-form-2")
        .find('[name="id"]')
        .val();
      const bundleToAdd = [variantId1, variantId2];
      populateQuickView(productsToAdd, bundleToAdd);
      $(".js-holiday-bag-modal").addClass("is-active");
    });

    //Bind click to show modal quickview
    $dom.addBundleToCart.on("click", () => {
      const productsToAdd = findActiveBundleProducts();
      const bundleToAdd = findActiveBundleVariants();
      populateQuickView(productsToAdd, bundleToAdd);
      $(".js-holiday-bag-modal").addClass("is-active");
    });

    //Reset QuickView pressing X
    $dom.quickViewClose.on("click", () => {
      resetQuickView();
    });

    //Reset QuickView pressing background
    $dom.quickViewBg.on("click", () => {
      resetQuickView();
    });

    //Bind click on add bundle
    $(document).on("click", ".js-holiday-bundle-btn", () => {
      const basicBundleIds = createBundleArray();
      if (basicBundleIds.length) {
        updateItems(basicBundleIds).then(submitCustomizeForms);
      } else {
        submitCustomizeForms();
      }
    });

    // Force customization dropdowns to works
  };

  const submitCustomizeForms = () => {
    const customizeForms = document.querySelectorAll(
      ".js-holiday-bag-modal .js-holiday-bundle-form-customizer"
    );
    const nodesArray = [].slice.call(customizeForms);
    recursizeSubmission(nodesArray);
  };

  const recursizeSubmission = nodesArray => {
    if (nodesArray.length) {
      const form = nodesArray.pop();
      $(form).submit();
      setTimeout(() => {
        recursizeSubmission(nodesArray);
      }, 1500);
    } else {
      $(".js-holiday-bag-modal").removeClass("is-active");
      resetQuickView();
    }
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  //Find Active Tab and return bundle variant IDs
  const findActiveBundleVariants = () => {
    const selectedOption = $("[data-holiday-options]")
      .find(
        ".holiday-bundle-bag-looks-tabs-content-container:visible [aria-expanded='true']"
      )
      .attr("data-variant-bundle-ids")
      .replace(/\s+/g, "")
      .split(",");
    return selectedOption;
  };

  //Find Active Tab and return bundle product IDs (For populating the quickview)
  const findActiveBundleProducts = () => {
    const productBundle = $("[data-holiday-options]")
      .find(
        '.holiday-bundle-bag-looks-tabs-content-container:visible [aria-expanded="true"]'
      )
      .attr("data-product-handles")
      .replace(/\s+/g, "")
      .split(",");
    return productBundle;
  };

  //Populate Quickview with product ids and variant ids
  const populateQuickView = (productArray, variantArray) => {
    const modal = $(".js-holiday-bag-modal");
    modal.find(".js-modal-content").html(""); //empty
    productArray.forEach((item, index) => {
      $.get(
        "/products/" +
          item +
          "?variant=" +
          variantArray[index] +
          "&view=ajax-customize",
        function(html) {
          $(html)
            .find(".custom-modal-container")
            .addClass("position-" + index + "");
          modal.find(".js-modal-content").append(html);
        }
      );
    });
  };

  //Creates bundle of products that are not customizable
  const createBundleArray = () => {
    const bundleToAdd = $(".js-holiday-bag-modal").find("[data-variant-id]");
    const arrayItems = [];
    bundleToAdd.each((index, item) => {
      arrayItems.push(item.getAttribute("data-variant-id"));
    });
    return arrayItems;
  };

  // Adds the items and submits form for customizable item
  const updateItems = items => {
    let url = "/cart/add?";
    //create url
    items.forEach(variantId => {
      url += `&id[]=${variantId}`;
    });

    url += '&properties[Bundle]=true';
    //add items and reload cart
    return fetch(url, { credentials: "include" });
  };

  //Resets quickview
  const resetQuickView = () => {
    if ($(".js-custom-modal-container-bundle").length === 0) {
      return false;
    }
    $(".js-custom-modal-container-bundle").remove();
  };

  holidayBundleBagCart.init = init
})((window.holidayBundleBagCart = window.holidayBundleBagCart || {}), jQuery);
